<div class="voice-table-container">
  <div class="voice-filters">
    <div class="filter-group">
      <glxy-form-field [bottomSpacing]="'none'">
        <mat-checkbox [checked]="genderFilter().masculine" (change)="toggleGenderFilter('masculine', $event.checked)">
          <glxy-label>{{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.GENDER.MASCULINE' | translate }}</glxy-label>
        </mat-checkbox>
      </glxy-form-field>
      <glxy-form-field [bottomSpacing]="'none'">
        <mat-checkbox [checked]="genderFilter().feminine" (change)="toggleGenderFilter('feminine', $event.checked)">
          <glxy-label>{{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.GENDER.FEMININE' | translate }}</glxy-label>
        </mat-checkbox>
      </glxy-form-field>
    </div>

    @if (availableLanguages().length > 0) {
      <glxy-form-field [bottomSpacing]="'none'">
        <mat-select
          [value]="selectedLanguage()"
          (selectionChange)="selectedLanguage.set($event.value)"
          [placeholder]="'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.LANGUAGE' | translate"
        >
          <mat-option value="">{{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.ALL' | translate }}</mat-option>
          @for (language of availableLanguages(); track language) {
            <mat-option [value]="language">
              {{ language }}
            </mat-option>
          }
        </mat-select>
      </glxy-form-field>
    }
  </div>

  <div class="table-scroll-wrapper">
    <table mat-table [dataSource]="pagedVoiceRows()">
      <ng-container matColumnDef="selected" sticky>
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <mat-icon [color]="row.value === selectedVoice() ? 'primary' : undefined">
            {{ row.value === selectedVoice() ? 'check_circle' : 'radio_button_unchecked' }}
          </mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="preview" sticky>
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          @if (row.computedPreviewAudioUrl) {
            <button
              mat-icon-button
              (click)="previewVoice(row); $event.stopPropagation()"
              [attr.aria-label]="'Preview ' + row.name"
            >
              <mat-icon>
                {{ previewingVoice()?.value === row.value ? 'stop' : 'play_arrow' }}
              </mat-icon>
            </button>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.TABLE.NAME' | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <strong>{{ row.name }}</strong>
        </td>
      </ng-container>

      <ng-container matColumnDef="recommended">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          @if (row.recommended) {
            <glxy-badge color="green" size="small">
              {{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.RECOMMENDED' | translate }}
            </glxy-badge>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="gender">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.TABLE.GENDER' | translate }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.genderTranslationKey | translate }}</td>
      </ng-container>

      <ng-container matColumnDef="accent">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'AI_ASSISTANT.SETTINGS.VOICE_CONFIG.TABLE.ACCENT' | translate }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.region | translate }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [class.dimmed-row]="!row.matchesLanguage"
        (click)="selectVoice(row)"
      ></tr>
    </table>
  </div>
  @if (filteredVoiceRows().length > pageSize) {
    <mat-paginator
      [length]="filteredVoiceRows().length"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex()"
      (page)="onPageChange($event)"
      hidePageSize
    ></mat-paginator>
  }
</div>
